import { render, staticRenderFns } from "./AutobuyerIntervalLabel.vue?vue&type=template&id=7b5058aa&scoped=true"
import script from "./AutobuyerIntervalLabel.vue?vue&type=script&lang=js"
export * from "./AutobuyerIntervalLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5058aa",
  null
  
)

export default component.exports